import React from 'react';
import { Wand2 } from 'lucide-react';

export const GuidedSetupLauncher: React.FC<{
  onClick: () => void;
}> = ({ onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="fixed bottom-4 left-4 sm:left-1/2 sm:-translate-x-1/2 z-[55] inline-flex items-center gap-2 rounded-full bg-[#0B4778]/90 text-white shadow-lg hover:bg-[#0B4778]/95 active:bg-[#0B4778] transition-colors px-3 py-2"
      aria-label="Open Guided Setup"
    >
      <span className="inline-flex items-center justify-center h-9 w-9 rounded-full bg-white/15">
        <Wand2 className="h-5 w-5" />
      </span>
      <span className="text-sm font-semibold">Setup Wizard</span>
    </button>
  );
};

